/** Máximo de séries no gráfico de comparação de Relatórios */
export const MAX_COMPARE_SERIES = 6;

/**
 * Decide quais itens ficam marcados no picker de comparação.
 *
 * - Lista expandiu e ficou grande (> max): limpa (ex.: Todas as Unidades).
 * - Lista pequena (≤ max): marca preferidos (com dados).
 * - Lista grande estável + seleção manual: mantém previousKeys válidas
 *   (NÃO filtra por keysWithData — senão some o clique do usuário).
 */
export const resolveCompareSelection = ({
  validKeys = [],
  keysWithData = [],
  previousKeys = [],
  previousOptionsCount = 0,
  maxSeries = MAX_COMPARE_SERIES,
  allowKeepOnLarge = false,
} = {}) => {
  const preferredOrdered = validKeys.filter((key) =>
    (keysWithData.length ? keysWithData : validKeys).includes(key)
  );

  const kept = previousKeys.filter((key) => validKeys.includes(key));

  const optionsGrew = validKeys.length > previousOptionsCount;
  const largePicker = validKeys.length > maxSeries;

  // Select all / lista grande que expandiu: nunca herdar equipamento antigo
  if (largePicker && optionsGrew) {
    return [];
  }

  if (!largePicker) {
    return preferredOrdered.slice(0, maxSeries);
  }

  // Lista grande estável: só seleção manual (preserva o clique)
  if (allowKeepOnLarge && kept.length > 0) {
    return kept.slice(0, maxSeries);
  }

  return [];
};
